var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return this.managements.length > 0
    ? _c("div", { staticClass: "calendar-compact-container" }, [
        _c("div", { staticClass: "row" }, [
          _vm._m(0),
          _c(
            "div",
            { staticClass: "col" },
            [
              _c(
                "time-line",
                { staticClass: "mt-4 custom-time-line" },
                _vm._l(_vm.filteredManagements, function(item, index) {
                  return _c(
                    "time-line-item",
                    {
                      key: index,
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "date",
                            fn: function() {
                              return [
                                _c("div", { staticClass: "hour-container" }, [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "color-black font-14 font-weight-bold"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("date")(item.createdDate)
                                          ) +
                                          " "
                                      )
                                    ]
                                  ),
                                  _c("div", { staticClass: "text-right" }, [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "color-gray font-12 text-right pr-4"
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm._f("hour")(item.createdDate)
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  ])
                                ])
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "row", attrs: { id: "main-info" } },
                        [
                          _c(
                            "div",
                            { staticClass: "col-md-3 border-right pt-2" },
                            [
                              _c("div", { staticClass: "font-weight-bold" }, [
                                _vm._v(_vm._s(item.managementType))
                              ])
                            ]
                          ),
                          _c("div", { staticClass: "col-md-2" }, [
                            _c("div", { staticClass: "data-label" }, [
                              _vm._v("Usuario:")
                            ]),
                            _c("span", { staticClass: "data" }, [
                              _vm._v(_vm._s(item.user))
                            ])
                          ]),
                          _c("div", { staticClass: "col-md-5" }, [
                            _c("div", { staticClass: "data-label" }, [
                              _vm._v("Comentario:")
                            ]),
                            _c("span", { staticClass: "data" }, [
                              _vm._v(_vm._s(item.comment))
                            ])
                          ]),
                          item.canDelete
                            ? _c(
                                "div",
                                { staticClass: "col-md-2" },
                                [
                                  _c("action-button", {
                                    staticClass: "align-middle",
                                    attrs: {
                                      i: "fas fa-times-circle",
                                      text: "Eliminar",
                                      variant: "outline-danger mr-3"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.handleDeleteManagement(
                                          item.id,
                                          item.managementType
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ]
                      )
                    ]
                  )
                }),
                1
              ),
              _vm.hasMoreData
                ? _c("div", { staticClass: "col-12 text-center pt-4 mt-2" }, [
                    _c(
                      "button",
                      {
                        staticClass:
                          "bg-white btn-outline arrowButton font-18 w-30",
                        on: { click: _vm.getNext }
                      },
                      [
                        _c("i", {
                          staticClass: "far fa-angle-double-down mb-4"
                        })
                      ]
                    )
                  ])
                : _vm._e()
            ],
            1
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-md-12 text-bold bold mb-3 mt-4" }, [
      _c("i", { staticClass: "fa fa-info-circle color-orange" }),
      _vm._v(" Historial de Gestiones Realizadas ")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }